import Phaser from 'phaser';
import { AnimationKeys, ChaosFrame, SceneKeys, TextureKeys } from '../config/keys';

export class BootScene extends Phaser.Scene {
  constructor() {
    super(SceneKeys.Boot);
  }

  preload(): void {
    const assetBase = import.meta.env.BASE_URL;

    this.load.image(TextureKeys.Background, `${assetBase}assets/backgrounds/squirrel-launch-background.png`);
    this.load.spritesheet(TextureKeys.ChaosSheet, `${assetBase}assets/sprites/chaos-sheet.png`, {
      frameWidth: 362,
      frameHeight: 362,
    });
    this.load.spritesheet(TextureKeys.ObstacleSheet, `${assetBase}assets/sprites/chaos-sheet-uncolored.png`, {
      frameWidth: 362,
      frameHeight: 362,
    });
  }

  create(): void {
    this.createGeneratedUiTextures();

    this.anims.create({
      key: AnimationKeys.SquirrelFly,
      frames: [
        { key: TextureKeys.ChaosSheet, frame: ChaosFrame.SquirrelHappy },
        { key: TextureKeys.ChaosSheet, frame: ChaosFrame.SquirrelTumble },
        { key: TextureKeys.ChaosSheet, frame: ChaosFrame.SquirrelTriumph },
      ],
      frameRate: 8,
      repeat: -1,
    });

    this.scene.start(SceneKeys.Menu);
  }

  private createGeneratedUiTextures(): void {
    const panel = this.make.graphics({ x: 0, y: 0 }, false);
    panel.fillStyle(0xfff7d8, 0.92);
    panel.lineStyle(4, 0x28221a, 0.82);
    panel.fillRoundedRect(0, 0, 210, 64, 8);
    panel.strokeRoundedRect(0, 0, 210, 64, 8);
    panel.lineStyle(1, 0x5ba6cf, 0.24);
    panel.lineBetween(14, 22, 196, 20);
    panel.lineBetween(14, 42, 196, 44);
    panel.generateTexture(TextureKeys.PaperPanel, 210, 64);
    panel.destroy();

    const dot = this.make.graphics({ x: 0, y: 0 }, false);
    dot.fillStyle(0xff6c62, 1);
    dot.lineStyle(3, 0x28221a, 0.9);
    dot.fillCircle(12, 12, 8);
    dot.strokeCircle(12, 12, 8);
    dot.generateTexture(TextureKeys.AimDot, 24, 24);
    dot.destroy();
  }
}
